

















































































































































































































































import { Component, Ref, Mixins } from "vue-property-decorator";
import { Calendar, CalendarDispEvent } from "#/components/calendar/common";
import { Patient, DefaultPatient } from "#/model/patient";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import { app, install } from "#/mixins/firebase";
import { ApplyOffice } from "#/model/apply";
import CalendarTitleBeforeAfter from "#/components/calendar/CalendarTitleBeforeAfter.vue";
import IbowCalendar from "@/components/common_ibow/calendar/IbowCalendar.vue";
import { EventType } from "#/model/schedule/calendarType";

interface PatientAddOffice extends Patient {
  office?: ApplyOffice;
}

@Component({
  components: { CalendarTitleBeforeAfter, IbowCalendar }
})
export default class CalendarWebPrint extends Mixins(AxiosMixin, UtilMixin) {
  // カレンダーコンポーネント
  @Ref("calendar") private readonly calendar!: Calendar;
  /** イベント */
  private events: CalendarDispEvent[] = [];
  /** 利用者 */
  private patient: PatientAddOffice = DefaultPatient();
  /** 対象月 */
  private targetMonth = this.dateToStr(new Date(), "yyyy-MM-dd");
  /** 祝日表示フラグ */
  private dispHoliday = true;
  /** 訪問者を表示しないフラグ */
  private dispStaff = 1;
  /** 電話番号を表示するフラグ */
  private dispTelNo = 1;
  /** 印刷日を表示するフラグ */
  private dispPrintDate = 1;
  /** 個別予定表示フラグ */
  private dispIndividual = true;
  /** 職種を表示フラグ */
  private dispJob = 0;
  /** 開始時間のみ表示フラグ */
  private dispStartOnly = 0;

  /** タイトル */
  private get Title(): string {
    return (
      this.patient.info.last_name +
      this.patient.info.first_name +
      "さんのカレンダー"
    );
  }

  /** 表示用年月日 */
  private get YearMonth(): string {
    const [year, month] = this.targetMonth.split("-");
    return `${year}年${month}月`;
  }

  /** 事業所名 */
  private get OfficeName(): string {
    if (this.patient.office) {
      return this.patient.office.name;
    }
    return "";
  }

  /** 電話番号 */
  private get TelNo(): string {
    if (this.dispTelNo && this.patient.office) {
      return "TEL:" + this.patient.office.tel_no;
    }
    return "";
  }

  /** 印刷日 */
  private get PrintDate(): string {
    if (this.dispPrintDate) {
      return "印刷日:" + this.dateToStr(new Date(), "yyyy-MM-dd");
    }
    return "";
  }

  private get Events(): CalendarDispEvent[] {
    return this.events.filter(event => {
      if (!this.dispHoliday && event.type === EventType.Holiday) {
        return false;
      }

      // 開始日のみ表示判定
      const time = this.dispStartOnly
        ? event.visit_plan?.start_hm
        : event.visit_plan?.start_and_end;

      // 職種表示判定
      const visitor = this.dispJob
        ? event?.visitor_name_and_job
        : event?.visitor_name;

      //訪問予定あり
      if (
        event.type === EventType.VisitSchedule ||
        event.type === EventType.VisitScheduleAIRoute
      ) {
        //訪問者表示判定
        if (this.dispStaff) {
          event.name = time === "" ? visitor : time + "\n" + visitor;
        } else {
          event.name = time;
        }
      }

      // 個別予定
      if (
        event.type === EventType.IndivisualSchedule ||
        event.type === EventType.Situation
      ) {
        // 個別予定が非表示判定
        if (!this.dispIndividual) {
          return false;
        }
        event.name = time === "" ? visitor : time + "\n" + visitor;
      }
      return true;
    });
  }

  private created() {
    if (this.$route.query.target) {
      // yyyy-mm-dd hh:mmで来ることもあるのでyyyy-mm-ddに切り出す
      this.targetMonth = String(this.$route.query.target).substring(0, 10);
    }
    this.fetch();
  }

  private fetch() {
    this.postJsonCheck(
      window.base_url + "/api/schedule/patientschedule/get",
      {
        patient_id: Number(this.$route.params.id),
        target_date: this.targetMonth
      },
      res => {
        this.patient = res.data.patient;
        this.events = res.data.patient_events;
      }
    );
  }

  private close() {
    window.close();
  }

  /** Web印刷ボタンクリック */
  private webPrint() {
    app
      .delete()
      .then(function() {
        window.print();
      })
      .catch(function(error) {
        console.log("Error deleting app:", error);
      })
      .finally(function() {
        install();
      });
  }

  /** PDF印刷ボタンクリック */
  private pdfPrint() {
    this.makePdf(window.base_url + "/api/schedule/patientschedule/pdf", {
      target_date: this.targetMonth,
      patient: this.patient,
      patient_events: this.Events,
      disp_staff: this.dispStaff,
      disp_tel_no: this.dispTelNo,
      disp_print_date: this.dispPrintDate,
      disp_job: this.dispJob,
      disp_start_only: this.dispStartOnly
    });
  }
}
